module.exports = __webpack_public_path__ + "img/Etudiant.60f20baf.png";